import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeadertestComponent } from './headertest/headertest.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [HeadertestComponent],
  exports: [HeadertestComponent]
})
export class TestmModule { }
